import { AlertFormSectionKey } from './steps';

export type AlertRequiredField =
    | 'delivery'
    | 'name'
    | 'query'
    | 'reportDashboard'
    | 'reportDestination'
    | 'schedule'
    | 'slackChannels'
    | 'webhookSecret'
    | 'webhookUrl';

export const alertRequiredFieldDetails: Record<AlertRequiredField, { label: string; sectionKey: AlertFormSectionKey }> =
    {
        name: { label: 'Alert Name', sectionKey: 'identity' },
        query: { label: 'Trigger Condition', sectionKey: 'query' },
        delivery: { label: 'Delivery Method', sectionKey: 'delivery' },
        slackChannels: { label: 'Slack Channel', sectionKey: 'delivery' },
        reportDashboard: { label: 'Destination Dashboard', sectionKey: 'delivery' },
        reportDestination: { label: 'Destination Report', sectionKey: 'delivery' },
        webhookUrl: { label: 'Webhook Endpoint URL', sectionKey: 'delivery' },
        webhookSecret: { label: 'Webhook Signing Secret', sectionKey: 'delivery' },
        schedule: { label: 'Evaluation Schedule', sectionKey: 'schedule' },
    };
